module.exports = __webpack_public_path__ + "static/images/two-arrows-circle.874e872727dcbb05fba33927175b9390.svg";